import React from 'react';

import _ from 'lodash';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { formSelect } from 'shared/forms/RenderSelect';

import { fetchPositions } from './ducks';

class PositionField extends React.Component {
  componentDidMount() {
    const { fetchPositions } = this.props;

    fetchPositions({ value: '' });
  }

  fetchPositions = value => {
    const { fetchPositions } = this.props;

    fetchPositions({ value });
  };

  render() {
    const { positions, fieldName = 'profile.position', ...props } = this.props;

    return (
      <React.Fragment>
        <label className="form-label">
          What best describes your <b>current position</b>?{props.required &&
            '*'}
        </label>
        <Field
          name={fieldName}
          component={formSelect}
          isMulti={false}
          options={positions}
          onInputChange={_.debounce(this.fetchPositions, 300)}
          placeholder="Enter your current position..."
          {...props}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { positions } = state.shared.positionField;

  return {
    positions
  };
};

const mapDispatchToProps = {
  fetchPositions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionField);
